import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';

import { AppFacade } from '@app/app.facade';
import { MULTIPLE_CARRIERS, AIRLINES_PRICES_TITLES } from '@flight-results/constants/filters.constants';

@Pipe({
  name: 'listAirlineNames',
  standalone: false
})
export class ListAirlineNamesPipe implements PipeTransform {

  constructor(
    private facade: AppFacade,
    private transloco: TranslocoService
  ) { }

  transform(codes: string[]): Observable<string> {
    return this.facade.airlineEntities$
      .pipe(
        map(airlines => codes.map(code => airlines[code] ? airlines[code].name : code)),
        map(airlineNames => {
          let allNames = '';
          const lastIndex = airlineNames.length ? airlineNames.length - 1 : 0;
          airlineNames.forEach((name, index) => {
            if (name === MULTIPLE_CARRIERS) allNames += this.transloco.translate(AIRLINES_PRICES_TITLES[MULTIPLE_CARRIERS]);
            else allNames += name;
            if (index < lastIndex) allNames += ', ';
          });
          return allNames;
        })
      );
  }
}
